<script>
    import { scale } from 'svelte/transition';
    import Tabs from '../ui/Tabs.svelte';
    import TextInput from '../ui/TextInput.svelte';
    import ButtonText from '../ui/ButtonText.svelte';
    let joinGame = 0;
    let name = '';
    let gameCode = '';

    function play() {
        if (joinGame === 0) {
            functions.httpsCallable('createGame')(name).then(result => {
                console.log(result.data);
                gameCode = result.data;
            });
        }
    }
</script>

<div class="flex flex-col w-full items-center">
    <Tabs tabs={['New Game', 'Join Game']} styling="mb-2" bind:value={joinGame} />
    <TextInput styling="w-full" placeholder="Name" bind:value={name} />
    <ButtonText placeholder="Game Code" buttonText="Play" textActive={joinGame} on:click={play} />
</div>
